document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.includes("profil/profil-adatok/adategyeztetes")) {
        let modal = document.querySelector("#newsletterModal");

        function showModal() {
            if (modal) {
                modal.classList.add('show');
                modal.style.display = 'block';
                modal.setAttribute('aria-hidden', 'false');
                modal.setAttribute('role', 'dialog');
                document.body.classList.add('modal-open');
                document.body.style.overflow = 'hidden';

                const backdrop = document.createElement('div');
                backdrop.className = 'modal-backdrop fade show';
                backdrop.id = 'customBackdrop';
                document.body.appendChild(backdrop);

                const closeButton = modal.querySelector('.close');
                closeButton.addEventListener('click', function() {
                    hideModal();
                });

                backdrop.addEventListener('click', function() {
                    hideModal();
                });
            }
        }

        function hideModal() {
            if (modal) {
                modal.classList.remove('show');
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';

                const backdrop = document.getElementById('customBackdrop');
                if (backdrop) {
                    backdrop.parentNode.removeChild(backdrop);
                }
            }
        }

        if (newsletterModal) {
            showModal();
        }
    }
});